import { onIdle, shopifyFormatCurrency } from "@mzw/utilities";
import "@mzw/components/lazy-product-card";

export class SimpleRecommendations extends HTMLElement {
	/** @type {HTMLUListElement} */
	list;

	get productId() {
		return this.getAttribute("product-id");
	}

	get intent() {
		return this.getAttribute("intent") || "related";
	}

	get limit() {
		return this.getAttribute("limit") || 3;
	}

	get loaded() {
		return this.hasAttribute("loaded");
	}

	set loaded(value) {
		if (value) {
			this.setAttribute("loaded", "");
		} else {
			this.removeAttribute("loaded");
		}
	}

	connectedCallback() {
		this.list = this.querySelector("ul");
		this.addEventListener("click", this);
		if (!this.loaded) this.getRecommendedations();
	}

	disconnectedCallback() {
		this.removeEventListener("click", this);
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === "product-id" && oldValue !== newValue) {
			this.getRecommendedations();
		}
	}

	handleEvent(event) {
		if (event.type === "click" && event.target.tagName === "BUTTON") {
			event.preventDefault();
			const productId = event.target.dataset.id;
			globalThis.liquidAjaxCart.add({
				items: [{ id: productId, quantity: 1 }],
			});
		}
	}

	async getRecommendedations() {
		const data = await fetch(
			`${globalThis.Shopify.routes.root}recommendations/products.json?product_id=${this.productId}&limit=${this.limit}&intent=${this.intent}`
		)
			.then((response) => response.json())
			.catch((error) => {
				console.error(error);
				globalThis.Bugsnag?.notify(error);
				globalThis.Sentry?.captureException(error);
			});

		if (data?.products?.length > 0) {
			this.recommendations = data?.products;
			onIdle(() => {
				this.render();
			});
		}
	}

	async render() {
		this.list.innerHTML = "";
		for (const product of this.recommendations) {
			if (product.type.toLowerCase().includes("gift")) continue;
			const listItem = document.createElement("li");
			listItem.innerHTML = /*html*/ `
				<a href="${product.url}">
					<img src="${product.featured_image}" alt="${product.title}" loading="lazy" />
				</a>
				<div><strong>${product.title}</strong></div>
				<div><span>${
					shopifyFormatCurrency(product.price, "${{amount}}")
				}</span></div>
				<a
					class="block size-2xs underline text-uppercase"
					href="${globalThis.routes.cart_add_url}?id=${product.variants[0].id}&quantity=1"
				>
					${globalThis.variantStrings.addToCart ?? "Add to Cart"}
				</a>
			`;
			// listItem.innerHTML = /*html*/ `
			// 	<lazy-product-card handle="${product.handle}">
			// 		<div class="product-card card-product-skeleton">
			// 			<div class="card-product-skeleton__image"></div>
			// 			<div class="card-product-skeleton__details">
			// 				<div class="card-product-skeleton__title-price">
			// 					<div class="card-product-skeleton__title"></div>
			// 					<div class="card-product-skeleton__price"></div>
			// 				</div>
			// 			</div>
			// 		</div>
			// 	</lazy-product-card>
			// `;
			this.list.append(listItem);
		}
		this.loaded = true;
	}
}

if (!customElements.get("simple-recommendations")) {
	customElements.define("simple-recommendations", SimpleRecommendations);
}
